import { disablePageScroll, enablePageScroll } from "scroll-lock";

function togglePopups() {
  let popup = $('.popup');

  let popupLogin = $('.popup-login');
  let popupOneClick = $('.popup-one-click');
  let popupQuestion = $('.popup-question');
  let popupRegistration = $('.popup-registration');
  let popupReview = $('.popup-review');
  let bg = $('.popup__bg');

  let close = $('.popup__close');

  let buttonLogin = $('.trigger-login');
  let buttonOneClick = $('.trigger-one-click');
  let buttonQuestion = $('.trigger-question');
  let buttonRegistration = $('.trigger-registration');
  let buttonReview = $('.trigger-review');

  function closePopup() {
    popup.removeClass('active');
    bg.removeClass('active');
    enablePageScroll();
  }

  close.on('click', function() {
    closePopup();
    popup.removeClass('active');
    bg.removeClass('active');
    enablePageScroll();
  });

  buttonLogin.on('click', function() {
    closePopup();
    popupLogin.addClass('active');
    bg.addClass('active');
    disablePageScroll();
  });

  buttonOneClick.on('click', function() {
    closePopup();
    popupOneClick.addClass('active');
    bg.addClass('active');
    disablePageScroll();
  });

  buttonQuestion.on('click', function() {
    closePopup();
    popupQuestion.addClass('active');
    bg.addClass('active');
    disablePageScroll();
  });

  buttonRegistration.on('click', function() {
    closePopup();
    popupRegistration.addClass('active');
    bg.addClass('active');
    disablePageScroll();
  });

  buttonReview.on('click', function() {
    closePopup();
    popupReview.addClass('active');
    bg.addClass('active');
    disablePageScroll();
  });
}
togglePopups();